import { render, staticRenderFns } from "./CircRnaSingleGeneExpression.vue?vue&type=template&id=3cb2ef98&scoped=true"
import script from "./CircRnaSingleGeneExpression.vue?vue&type=script&lang=js"
export * from "./CircRnaSingleGeneExpression.vue?vue&type=script&lang=js"
import style0 from "./CircRnaSingleGeneExpression.vue?vue&type=style&index=0&id=3cb2ef98&prod&scoped=true&lang=css"
import style1 from "./CircRnaSingleGeneExpression.vue?vue&type=style&index=1&id=3cb2ef98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb2ef98",
  null
  
)

export default component.exports